import React, { Suspense} from "react";
import { ToastContainer } from "react-toastify";
import RouterApp from "./router";
import { UsuarioProvider } from "./context/usuarioContext";
import "react-toastify/dist/ReactToastify.min.css";
import "./style.scss";
import Layout from "./layouts/Layout";
import LoadingMask from "./librerias/LoadingMask/LoadingMask";
import { useLoading } from "./context/loadingContext";

const App = () => {
  const { loadingState } = useLoading();
  return (
    <>
      <UsuarioProvider>
        <Suspense fallback={<Layout />}>
          <RouterApp />
        </Suspense>
        <ToastContainer />
        <LoadingMask open={loadingState.length > 0} loadingText={loadingState.length > 0 ? loadingState[loadingState.length - 1].message : 'Cargando...'}/>
      </UsuarioProvider>
    </>
  );
};

export default App;
